export default {
  SEARCH_CATALOG_ALLIANZ_STATE_QUERY: Symbol.for('SEARCH_CATALOG_ALLIANZ_STATE_QUERY'),
  CATALOG_ALLIANZ_STATE_REPOSITORY: Symbol.for('CATALOG_ALLIANZ_STATE_REPOSITORY'),
  CATALOG_ALLIANZ_STATE_STATE_MANAGER: Symbol.for('CATALOG_ALLIANZ_STATE_STATE_MANAGER'),
};
